import '.c8{position:relative;}.ssr-plugin'
import '.jp{width:64px;}.ssr-plugin'
import '.jq{height:64px;}.ssr-plugin'
import '.bl{flex-shrink:0;}.ssr-plugin'
import '.b9{position:absolute;}.ssr-plugin'
import '.jr{bottom:-4px;}.ssr-plugin'
import '.hh{right:-4px;}.ssr-plugin'
import '.d2{border-radius:50%;}.ssr-plugin'
import '.dp{border:2px solid var(--palette-white);}.ssr-plugin'
import '.ae{overflow:hidden;}.ssr-plugin'
import '.js{width:32px;}.ssr-plugin'
import '.jt{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'
import { StoredImage } from '@app/types/StoredImage'

type ConversationAvatarProps = {
  initiativeImage?: StoredImage
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  const hasImage = !!initiativeImage && !!initiativeImage.src
  return (
    <div className="c8 jp jq bl"
    >
      {hasImage ? (
        <Image
          src={initiativeImage.src}
          alt={initiativeImage.altText || 'initiative image'}
          resizeWidth={128}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="b9 jr hh d2 dp ae js jt"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
